

const responsiveFont = (theme) => {

  theme.typography.h1 = {
    fontSize: '3.0rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '4.5rem',
    },
  }

  theme.typography.h2 = {
    fontSize: '2.6rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '3.9rem',
    },
  }


  theme.typography.h3 = {
    fontSize: '2.2rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '3.3rem',
      fontWeight: 500,
    },
  }


  theme.typography.h4 = {
    fontSize: '1.8rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '2.3rem',
      fontWeight: 500,
    },
  }

  theme.typography.h5 = {
    fontSize: '1.4rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.9rem',
      fontWeight: 500,
    },
  }

  theme.typography.h6 = {
    fontSize: '1.0rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
  }


  theme.typography.subtitle1={
    fontSize: '1.2rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },
  }

  theme.typography.subtitle2={
    fontSize: '1.0rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3rem',
    },
  }

  theme.typography.body1={
    fontSize: '1.0rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.3rem',
    },
  }

  theme.typography.body2={
    fontSize: '0.9rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.2rem',
    },
  }

  return theme
}

export { responsiveFont };
